module.exports = __webpack_public_path__ + "static/media/Configuracion.31bfcace.svg";